const Loading = () => {
  return <>Loading ...</>
}

export default Loading;